<template>
  <div class="myswiper-container">
    <div class="swiper-outer-div">
      <swiper :options="swiperOptions" ref="mySwiper">
        <swiper-slide v-for="(item, index) of swiperList.rows" :key="index">
          <div :class="{ 'swiper-img-Border': index === realIndex }"></div>
<!--          <img-->
<!--            class="swiper-img"-->
<!--            :src="item.images"-->
<!--            :class="{ 'swiper-img-current': index === realIndex }"-->
<!--          />-->
          <img :src="item.colorImages" v-if="index === realIndex" class ="swiper-img swiper-img-current"/>
          <img :src="item.images" class="swiper-img" v-else />
        </swiper-slide>
      </swiper>
    </div>

    <div class="swiper-text">
      <div class="swiper-name">{{ swiperList.rows[realIndex].userName }}</div>
      <div class="swiper-desc">
        {{ swiperList.rows[realIndex].introduction }}
      </div>
    </div>
  </div>
</template>

<script>
// import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// import { GetPartnerList } from "../../assets/server/api";
// import "swiper/swiper.less";
export default {
  name: "TeamMember",
  components: {
    // Swiper,
    // SwiperSlide,
  },
  computed: {
    // showSwiper() {
    //   return this.swiperList.length;
    // },
    currentSwiperData() {
      //当前slide数据
    //  return this.swiperList[this.realIndex];
    },
    swiper() {
    //  return this.$refs.mySwiper.$swiper;
    },
  },
  watch: {},
  data() {
    let _this = this;
    return {
      realIndex: 0, //轮播图滚动当前index
      timer: null,
      swiperOptions: {
        // direction: 'vertical',
        notNextTick: true,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        slidesPerView: 5, //一行显示5个
        spaceBetween: 10, //间隔
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChangeTransitionStart: function () {
            _this.realIndex = this.realIndex;
          },
          slideChangeTransitionEnd() {},
          slideChange: () => {},
        },
      },
      observer: true, // 修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, // 修改swiper的父元素时，自动初始化swiper
      swiperList: [],
    };
  },
  created() {
   // this.GetPartnerList();
  },
  methods: {
    init() {
      let _this = this;
      this.timer = setInterval(() => {
        _this.swiper.slideNext(500);
      }, 3000);
    },
    // 核心成员
    async GetPartnerList() {
      const data = await GetPartnerList();
      // console.log(data);
      if (data.code === 0) {
        // data.rows.forEach((item) => {
        //   item.images1 = "https://www.donetwork.io/team/chris.png";
        // });
        this.swiperList = data;
      } else {
        this.$message.error(data.msg);
      }
      // this.swiperList = await GetPartnerList();
    },
  },
  destroyed() {
    clearInterval(this.timer);
  },
  mounted() {
    // this.init();
  },
};
</script>

<style lang="less" scoped>
.myswiper-container {
  width: 100%;
  margin: 100px auto;
  .swiper-outer-div {
    // border: 1px solid #f00;
    background-image: url("../../assets/m/team/team_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .swiper-container {
    position: relative;
    top: 43px;
    padding-top: 20px;
    padding-left: 20px;
    width: 600px;
    height: 189px;
    .swiper-wrapper {
      .swiper-slide {
        .swiper-img {
          width: 67px;
          height: 67px;
          border-radius: 50%;
        }
        .swiper-img-current {
          margin-top: -15px;
          width: 100px;
          height: 100px;
          border-radius: 50%;
        }
        .swiper-img-Border {
          position: absolute;
          top: -20px;
          left: -5px;
          width: 110px;
          height: 110px;
          border: 2px solid #4573e7;
          border-radius: 50%;
        }
      }
    }
  }
  .swiper-text {
    text-align: center;
    .swiper-name {
      height: 49px;
      font-size: 30px;
      font-family: Poppins-Bold, Poppins;
      font-weight: bold;
      color: #4573e7;
      line-height: 35px;
      -webkit-background-clip: text;
    }
    .swiper-desc {
      height: 177px;
      margin: 0 50px;
      font-size: 26px;
      font-family: Poppins-Regular, Poppins;
      font-weight: 400;
      color: #000000;
      line-height: 44px;
      -webkit-background-clip: text;
    }
  }
}
</style>
